export default __webpack_public_path__ + "assets/audios/2b3a201481865554cdfe46ab7b413baa.mp3";